import ModalTitleBarWithSideButtons from '../../Modals/ModalTitleBarWithSideButtons';
import { useAddNewLocationModalContext } from './AddNewLocationModalProvider';

const AddNewLocationModalTitle = ({
  setDrawerToClose,
}: {
  setDrawerToClose: () => void;
}) => {
  const { isAddOtherLocationChosen, setIsAddOtherLocationChosen } =
    useAddNewLocationModalContext();

  return (
    <ModalTitleBarWithSideButtons
      onModalClose={setDrawerToClose}
      onBackClick={
        isAddOtherLocationChosen
          ? () => setIsAddOtherLocationChosen(false)
          : undefined
      }
    />
  );
};

export default AddNewLocationModalTitle;
